import { useEffect } from 'react';
import { usePreferenceStore } from '../store/store';

/**
 * Initializes the preference store by:
 * - Setting a custom storage key (optional per-user)
 * - Manually hydrating from IndexedDB
 * - Triggering GET API bootstrap
 */

let hasInitialized = false;

export const usePreferencesInitializer = (userId?: string) => {
  useEffect(() => {
    if (!hasInitialized && !usePreferenceStore.getState().isHydrated) {
      hasInitialized = true;
      usePreferenceStore.persist.setOptions({
        name: `user-preferences-state${userId ? `-${userId}` : ''}`,
      });

      usePreferenceStore.persist.rehydrate();
    }
  }, []);
};
